// @flow
import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import i18n from 'i18n-js';

import { MdChevronRight, MdKeyboardArrowDown } from 'react-icons/lib/md';
import * as selectors from '../../reducers';
import CardRow from '../CardRow';

import CardHeader from '../CardHeader';
import CardContent from '../CardContent';
import CardHeaderLeftContent from '../CardHeaderLeftContent';
import CardHeaderRightContent from '../CardHeaderRightContent';
import ChangeStopCardTitle from './ChangeStopCardTitle';
import ChangeStopCardSubtitle from './ChangeStopCardSubtitle';
import ChangeStopCardContent from './ChangeStopCardContent';
import ChangeStopActionButton from './ChangeStopActionButton';
import styles from './changeStopRequestCard.css';

import type { CHANGE_STOP_REQUEST_TYPE } from '../../types/changeStopRequest';
import type { ROUTE_STOP_TYPE, ROUTE_TYPE } from '../../types/routes';
import type { USER_TYPE } from '../../types/users';
import type { STUDENT_TYPE } from '../../types/student';
import { getUserImage } from '../../utils';

type ChangeStopRequestCardPropTypes = {
  // children?: Node,
  changeStopRequest: CHANGE_STOP_REQUEST_TYPE,
  requestedBy: USER_TYPE,
  instance_type: string,
  fromStop: ROUTE_STOP_TYPE,
  fromRoute?: ROUTE_TYPE,
  toRoute?: ROUTE_TYPE,
  toStop: ROUTE_STOP_TYPE,
  fromGateway: ROUTE_STOP_TYPE,
  student: STUDENT_TYPE,
  toGateway: ROUTE_STOP_TYPE,
  id: string,
  requestedAt: string,
};

type ChangeStopRequestCardStateTypes = {
  // children?: Node,
  showDetails?: boolean
};

class ChangeStopRequestCard extends Component
<ChangeStopRequestCardPropTypes, ChangeStopRequestCardStateTypes> {
  constructor(props) {
    super(props);
    this.state = { showDetails: false };
  }

  render() {
    const {
      fromStop,
      fromRoute,
      toRoute,
      toStop,
      fromGateway,
      toGateway,
      student,
      requestedBy,
      changeStopRequest,
      id,
      requestedAt,
      instance_type,
    } = this.props;
    // Depending on the instance type we render a fromStop o fromGateway
    let fromElement = fromGateway ? fromGateway.name : 'N/A';
    let toElement = toGateway.name;
    const { showDetails } = this.state;
    if (fromGateway && fromGateway.name === 'Bus' && fromStop) {
      fromElement = fromStop.name;
    }
    if (toGateway && toGateway.name === 'Bus') {
      toElement = toStop.name;
    }
    let rightContent = null;
    if (changeStopRequest.state === 'pending') {
      rightContent = (
        <div className={styles.rightContent}>
          <ChangeStopActionButton
            id={id}
            tint="mediumGray"
            title={i18n.t('buttons.reject')}
            state="rejected"
            instance_type={instance_type}
            isOutlined
            clearMargins
          />
          <ChangeStopActionButton
            id={id}
            title={i18n.t('buttons.aprove')}
            state="approved"
            instance_type={instance_type}
            clearMargins
            className={styles.aproveButton}
            requireConfirmation={false}
          />
        </div>
      );
    } else if (changeStopRequest.state === 'approved') {
      rightContent = (
        <div className={styles.rightContent}>
          <h2 className={styles.approveText}>APROBADO</h2>
        </div>
      );
    } else if (changeStopRequest.state === 'rejected') {
      rightContent = (
        <div className={styles.rightContent}>
          <h2 className={styles.approveText}>RECHAZADO</h2>
        </div>
      );
    }


    return (
      <CardRow className={styles.row}>
        <div className={styles.col}>

          <div className={styles.cardHeader}>
            <div className={styles.leftContent}>
              <div className={styles.detailContent}>
                <span
                  onClick={(_e) => {
                    const { showDetails } = this.state;
                    return this.setState({ showDetails: !showDetails });
                  }}
                  className={styles.chevron}
                >
                  {
                    showDetails
                      ? <MdKeyboardArrowDown size={32} />
                      : <MdChevronRight size={32} />
                  }
                </span>
              </div>
              <div className={styles.col}>
                <div className={styles.row}>
                  {
                    student && (
                      <ChangeStopCardTitle
                        studentFirstName={student.first_name}
                        fromStop={fromElement ? fromElement : 'N/A'}
                        toStop={toElement ? toElement : 'N/A'}
                        studentLastName={student.last_name}
                        studentPicture={getUserImage(student.profile_picture)}
                      />
                    )
                  }
                </div>
                <div className={styles.row}>
                  {
                    requestedBy
                    && <ChangeStopCardSubtitle
                      requestedByFirstName={requestedBy.first_name}
                      requestedByLastName={requestedBy.last_name}
                      requestedAt={requestedAt}
                      start={changeStopRequest.start_date}
                      end={changeStopRequest.end_date}
                    />
                  }
                </div>
              </div>

            </div>
            {rightContent}
          </div>

          <CardContent
            className={
              `
              ${typeof changeStopRequest.description !== 'string' ? styles.noDescription : ''}
              ${styles.cardContent}
              ${showDetails ? styles.visibleDetails : styles.hiddenDetails}
              `
            }
          >
            <ChangeStopCardContent
              requestedByLastName={requestedBy.last_name}
              requestedByFirstName={requestedBy.first_name}
              description={changeStopRequest.description}
            />
          </CardContent>

        </div>
      </CardRow>
    );
  }
}

export const ConnectedChangeStopRequestCard = connect(
  (state, props) => {
    const { changeStopRequest } = props;
    const student = selectors.getStudent(state, changeStopRequest.student);
    const fromStop = changeStopRequest.from_stop ? selectors.getRouteStop(state,
      changeStopRequest.from_stop) : undefined;
    const toStop = changeStopRequest.to_stop ? selectors.getRouteStop(state,
      changeStopRequest.to_stop) : undefined;
    const fromGateway = changeStopRequest.from_gateway ? selectors.getGateway(state,
      changeStopRequest.from_gateway) : undefined;
    const toGateway = changeStopRequest.to_gateway ? selectors.getGateway(state,
      changeStopRequest.to_gateway) : undefined;
    const fromRoute = { short_name: '' };
    const toRoute = { short_name: '' };
    const requestedAt = new Date(changeStopRequest.requested_at)
      .toLocaleString('en-US', { hour: 'numeric', minute: 'numeric', hour12: true })
    // if (fromStop) {
    //   fromRoute = fromStop.route ? selectors.getRoute(state,
    //     fromStop.route) : undefined;
    // }
    // if (toStop) {
    //   toRoute = toStop.route ? selectors.getRoute(state,
    //     toStop.route) : undefined;
    // }
    return {
      student,
      fromRoute,
      toRoute,
      fromStop,
      fromGateway,
      toStop,
      toGateway,
      requestedAt,
      instance_type: changeStopRequest.instance_type,
      requestedBy: changeStopRequest.requested_by,
    };
  },
  undefined,
)(ChangeStopRequestCard);

export default ConnectedChangeStopRequestCard;



// WEBPACK FOOTER //
// ./src/scripts/components/ChangeStopRequestCard/index.jsx